export default "__VITE_ASSET__3dfbb272__"